import withReducer from '../../store/withReducer'
import RequestNewPassword from './container'
import reducer from './module'

export default withReducer('requestNewPassword', reducer)(RequestNewPassword)



// WEBPACK FOOTER //
// ./src/legacy/pages/RequestNewPassword/index.js